import { css, type Theme } from "@emotion/react";

import { dimensions, layers } from "@styles";

export const wrapper = {
  base: css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.5rem;
    width: 6rem;
  `,
  isSmall: css`
    height: 2rem;
  `,
  hasMargin: css`
    margin-right: 0.5rem;
  `,
  hasIcon: css`
    width: auto;
  `,
};

export const button = {
  wrapper: css`
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  content: (theme: Theme) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${theme.aviaryTypography.body.fontSize};

    background-color: ${theme.input.backgroundInformation};
    color: ${theme.system.textBase};
    padding: 0;
    height: 100%;
    width: 100%;
    z-index: ${layers.indexDefault};
    border-top: 1px solid ${theme.system.borderBase};
    border-bottom: 1px solid ${theme.system.borderBase};

    &:enabled {
      &:hover {
        color: ${theme.text.onBackground};
        background-color: ${theme.primary.backgroundBase};
        cursor: pointer;
      }
    }

    &:disabled {
      cursor: not-allowed;
      box-shadow: none;
      color: ${theme.disabled.inputLabelText};
      background-color: ${theme.disabled.background};
    }

    svg {
      font-size: ${theme.aviaryTypography.footnote.fontSize};
    }
  `,
  active: (theme: Theme) => css`
    border-color: ${theme.input.borderActive};
  `,
  hasIcon: css`
    width: 4rem;
  `,
};

export const leftButton = (theme: Theme) => css`
  ${button.content(theme)};
  border-left: 1px solid ${theme.system.borderBase};
  border-right: none;
  border-radius: ${dimensions.borderRadius} 0 0 ${dimensions.borderRadius};
`;

export const leftButtonWithIcon = css`
  border-radius: 0;
  padding: 0 0.5rem;
`;

export const rightButton = (theme: Theme) => css`
  ${button.content(theme)};
  border-right: 1px solid ${theme.system.borderBase};
  border-left: none;
  border-radius: 0 ${dimensions.borderRadius} ${dimensions.borderRadius} 0;
`;

export const input = {
  wrapper: css`
    width: 2rem;
    height: 100%;
  `,
  content: (theme: Theme) => css`
    font-size: 16px;
    border-top: 1px solid ${theme.system.borderBase};
    border-bottom: 1px solid ${theme.system.borderBase};
    border-left: none;
    border-right: none;
    color: ${theme.system.textLabelEmphasis};
    height: 100%;
    width: 100%;
    text-align: center;
    font-weight: 600;
    padding-left: 0;
    padding-right: 0;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    &[type="text"] {
      // This for mobile styles to not show up
      border-radius: 0;
      appearance: none;
    }
    &[disabled] {
      background-color: ${theme.disabled.inputBackground};
      color: ${theme.disabled.inputLabelText};
    }
  `,
  active: (theme: Theme) => css`
    border-color: ${theme.input.borderActive};
  `,
};

export const icon = (theme: Theme) => css`
  border: 1px solid ${theme.system.borderBase};
  border-right: 0;
  border-radius: ${dimensions.borderRadius} 0 0 ${dimensions.borderRadius};
  padding: 0.4375rem 0.5rem;
  background-color: ${theme.system.backgroundMuted};
`;

export const iconSmall = css`
  padding: 0.1875rem 0.5rem;
`;
